import { Area, AreaChart, CartesianGrid, XAxis } from 'recharts';
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from '@/core/design-system/Chart';
import useGetTrafficGraph from '@/modules/analytics/hooks/useGetTrafficGraph.hook';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { useEffect } from 'react';
import { useAnalytics } from '@/modules/analytics/hooks/useAnalytics.hook';
import GraphSkeleton from '../../skeletons/GraphSkeleton';

const chartConfig = {
  visitors: {
    label: 'Visitors',
    color: 'var(--graph-chart-1)',
  },
  clicks: {
    label: 'Clicks',
    color: 'var(--graph-chart-2)',
  },
} satisfies ChartConfig;

const TrafficGraph = () => {
  const { state } = usePlayground();
  const { dateFilter, filters } = useAnalytics();
  const getTrafficGraph = useGetTrafficGraph();

  useEffect(() => {
    if (!state.payload?._id) return;

    getTrafficGraph.mutate({
      link_in_bio_id: state.payload._id,
      start_date: dateFilter.start,
      end_date: dateFilter.end,
      ...filters,
    });
  }, [state.payload?._id, dateFilter, filters]);

  if (!getTrafficGraph.data) return <GraphSkeleton />;

  return (
    <ChartContainer config={chartConfig}>
      <AreaChart
        accessibilityLayer
        data={getTrafficGraph.data.data}
        margin={{
          left: 50,
          right: 50,
          top: 5,
          bottom: 5,
        }}
      >
        <CartesianGrid vertical={false} stroke="var(--secondary)" />
        <XAxis dataKey="label" tickLine={false} axisLine={false} tickMargin={8} hide />
        <ChartTooltip cursor={false} content={<ChartTooltipContent />} />
        <defs>
          <linearGradient id="fillVisitors" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="var(--color-visitors)" stopOpacity={0.8} />
            <stop offset="95%" stopColor="var(--color-visitors)" stopOpacity={0.1} />
          </linearGradient>
          <linearGradient id="fillClicks" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="var(--color-clicks)" stopOpacity={0.8} />
            <stop offset="95%" stopColor="var(--color-clicks)" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Area
          dataKey="clicks"
          type="natural"
          fill="url(#fillClicks)"
          fillOpacity={0.4}
          stroke="var(--color-clicks)"
          stackId="a"
        />
        <Area
          dataKey="visitors"
          type="natural"
          fill="url(#fillVisitors)"
          fillOpacity={0.4}
          stroke="var(--color-visitors)"
          stackId="a"
        />
      </AreaChart>
    </ChartContainer>
  );
};

export default TrafficGraph;
